/* eslint-disable no-unused-vars */
import axios from "axios";
import * as XLSX from "xlsx";
import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Card, Button, Col, Row, Form, Upload } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { saveUploadCsvStock } from "../../../@app/subMaster/subMasterSlice";
//import ConfirmOnExit from "../../../components/confirmOnExit/ConfirmOnExit";
import messageToast from "../../../components/messageToast/messageToast";

function StockUploadFormCsv() {
  const {
    state: { data: defaultValue = {}, isEdit = false }
  } = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState([]);

  const {
    savingStockUpload,
    getStockUploadResponse: { data: newCSV }
  } = useSelector((state) => {
    return state.subMaster;
  });

  const handleClickBack = () => {
    navigate("/stockUploadDetails");
  };

  const onFinish = () => {
    try {
      if (!Array.isArray(data) || data.length === 0) {
        messageToast({
          message: "Please select an Excel file to upload before submitting.",
          status: 400,
          title: "Stock Upload Details"
        });
        return;
      }

      let i = 0;
      let payload = [];
      data.forEach((e) => {
        if (i !== 0 && e && e.length > 0) {
          const innerdata = {
            outlet_name: e[0],
            outlet_code: e[1],
            sku: e[2],
            type: e[3],
            category: e[4],
            name: e[6],
            measuring_unit: e[7],
            qty_per_batch: e[8],
            batch_number: e[9],
            expiry_date: e[10],
            expired: e[11]
          };
          payload.push(innerdata);
        }
        i++;
      });

      if (payload.length === 0) {
        messageToast({
          message: "No valid rows found in the uploaded file.",
          status: 400,
          title: "Stock Upload Details"
        });
        return;
      }

      dispatch(saveUploadCsvStock({ data: payload })).then(
        ({ message, status, statusText }) => {
          if (status === 200) {
            navigate("/stockUploadDetails");
            messageToast({
              message: message ?? statusText,
              status: 200,
              title: "Stock Upload Details"
            });
          } else {
            messageToast({
              message: message ?? statusText,
              status: 400,
              title: "Stock Upload Details"
            });
          }
        }
      );
    } catch (err) {
      messageToast({
        message: "something went wrong",
        status: 400,
        title: "Stock Upload Details"
      });
    }
  };

  return (
    <>
      <Card>
        {/* <ConfirmOnExit showModel={showDialog} /> */}
        <Row style={{ justifyContent: "center" }}>
          <Col span={24}>
            <Form
              name="basic"
              //  onFieldsChange={() => setShowDialog(true)}
              labelCol={{ span: 24 }}
              form={form}
              disabled={savingStockUpload}
              wrapperCol={{ span: 24 }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Row gutter={[25, 0]}>
                <Col md={{ span: 4 }} xs={{ span: 16 }}>
                  <Upload
                    beforeUpload={() => false}
                    // accept=".xlsx, .xls"
                    name="logo"
                    multiple=""
                    showUploadList={{ showPreviewIcon: false }}
                    onChange={async (filesData) => {
                      try {
                        const fileObj =
                          filesData?.file?.originFileObj || filesData?.file;
                        if (!fileObj) return;

                        let buffer;
                        if (typeof fileObj.arrayBuffer === "function") {
                          buffer = await fileObj.arrayBuffer();
                        } else {
                          buffer = await new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = (e) => resolve(e.target.result);
                            reader.onerror = (e) => reject(e);
                            reader.readAsArrayBuffer(fileObj);
                          });
                        }

                        const workbook = XLSX.read(buffer, { type: "array" });
                        const worksheet =
                          workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                          header: 1
                        });
                        setData(jsonData);
                      } catch (err) {
                        messageToast({
                          message:
                            "Failed to parse selected file. Please ensure it is a valid Excel file.",
                          status: 400,
                          title: "Stock Upload Details"
                        });
                      }
                    }}
                    listType="xlsx"
                    maxCount={1}
                    withCredentials //this is what limits the number of files uploaded
                  >
                    <Button icon={<UploadOutlined />}>Click to upload</Button>
                  </Upload>
                </Col>

                <Col span={24}>
                  <Row gutter={[15, 15]} style={{ justifyContent: "end" }}>
                    <Col
                      span={12}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <Form.Item className="mx-2">
                        <Button
                          className="orangeFactory"
                          type="primary"
                          htmlType="submit"
                          loading={savingStockUpload}
                          disabled={savingStockUpload}
                        >
                          {isEdit ? "Update" : "Add"}
                        </Button>
                      </Form.Item>

                      <Form.Item>
                        <Button
                          disabled={savingStockUpload}
                          onClick={handleClickBack}
                        >
                          Back
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default StockUploadFormCsv;
